import { BrandProvider as BrandProvider$1, useBrand as useBrand$1 } from '@aviv-unified-frontend/runtime/brand';

const BrandProvider = BrandProvider$1;
const useBrand = useBrand$1;

export { BrandProvider, useBrand };
